function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M83.366 45.915a1.577 1.577 0 10.001 3.154 1.577 1.577 0 000-3.154z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M95.977 39.61H78.666l-4.998-9.995A4.704 4.704 0 0069.438 27H51.267a4.703 4.703 0 00-4.23 2.615L42.04 39.61h-3.124v-1.576a4.734 4.734 0 00-4.728-4.729h-3.153a4.734 4.734 0 00-4.729 4.729v1.576H24.73A4.734 4.734 0 0020 44.34v44.136a4.734 4.734 0 004.729 4.729h71.248a4.734 4.734 0 004.728-4.73V44.34a4.734 4.734 0 00-4.728-4.729zm-46.12-8.585c.269-.538.81-.872 1.41-.872h18.171c.601 0 1.141.334 1.41.872l4.293 8.585H45.564l4.293-8.585zm-20.4 7.009c0-.87.708-1.576 1.577-1.576h3.153c.869 0 1.576.707 1.576 1.576v1.576h-6.305v-1.576zm-6.304 17.323h19.932a20.499 20.499 0 00-3.224 11.05c0 3.942 1.129 7.762 3.224 11.034H23.153V55.357zm37.2-6.29c9.478 0 17.339 7.68 17.339 17.34 0 9.649-7.85 17.339-17.34 17.339-9.497 0-17.338-7.699-17.338-17.34 0-9.647 7.848-17.338 17.339-17.338zm37.2 39.408c0 .869-.707 1.576-1.576 1.576H24.728c-.87 0-1.576-.707-1.576-1.576v-7.882H45.57a20.505 20.505 0 0014.782 6.305c5.584 0 10.93-2.29 14.781-6.305h22.419v7.882zm0-11.034H77.62a20.446 20.446 0 003.223-11.034c0-3.942-1.128-7.761-3.223-11.034h19.932v22.068zm0-25.22H75.134a20.505 20.505 0 00-14.781-6.306c-5.585 0-10.931 2.29-14.782 6.305H23.153V44.34c0-.87.707-1.576 1.576-1.576h71.248c.869 0 1.576.707 1.576 1.576v7.881z",
  fill: "#384B51"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M65.082 33.305h-9.458a1.576 1.576 0 000 3.153h9.458a1.576 1.576 0 000-3.153z",
  fill: "#00BAC3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M60.353 52.22c-7.822 0-14.187 6.364-14.187 14.187 0 7.822 6.365 14.186 14.187 14.186 7.822 0 14.187-6.364 14.187-14.186 0-7.823-6.365-14.187-14.187-14.187zm0 25.22c-6.084 0-11.034-4.95-11.034-11.033 0-6.084 4.95-11.034 11.034-11.034 6.084 0 11.034 4.95 11.034 11.034 0 6.084-4.95 11.034-11.034 11.034z",
  fill: "#384B51"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M60.353 58.525c-4.346 0-7.882 3.536-7.882 7.882a1.576 1.576 0 003.153 0 4.734 4.734 0 014.729-4.73 1.576 1.576 0 000-3.152z",
  fill: "#00BAC3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M92.824 45.915h-3.152a1.576 1.576 0 000 3.153h3.152a1.576 1.576 0 000-3.153z",
  fill: "#384B51"
});

function SvgCamera(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCamera;